import script from "./HomeHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeHeader.vue?vue&type=script&lang=ts&setup=true"

import "./HomeHeader.vue?vue&type=style&index=0&id=5a85ed12&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a85ed12"]])

export default __exports__